import { Component, Input, Inject, OnChanges, } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { Config } from '../universal-config';
import { ShareCopyService } from '../share';

@Component({
  selector: 'nns-embed-header',
  template: `
    <div class="nns-embed-header__left">
      <a href="{{websiteUrl}}" target="_blank" class="nns-embed-logo">
        <nns-icon icon="get-nimbus-note" *ngIf="(!share || !share.instance || !share.instance.org || !share.instance.org.smallLogoStoredFileUUID) && (!branding || !branding.sharesLogoStoredFileUUID)"></nns-icon>

        <img *ngIf="branding && branding.sharesLogoStoredFileUUID" src="{{fileUrl + branding.sharesLogoStoredFileUUID}}"/>

        <img *ngIf="(!branding || !branding.sharesLogoStoredFileUUID) && share && share.instance && share.instance.org && share.instance.org.smallLogoStoredFileUUID" src="{{fileUrl + share.instance.org.smallLogoStoredFileUUID}}"/>
      </a>
    </div>
    <div class="nns-embed-header__right">
      <a href="{{shareUrl}}" target="_blank" class="nns-embed-title" *ngIf="note">
        {{note.title}}
      </a>
      <div class="nns-embed-link">
        <a target="_blank" href="{{shareUrl}}" *ngIf="!visual?.isVideo" class="nns-href">
          <span *ngIf="note?.type == 'note'">Open this page</span>
          <span *ngIf="note?.type == 'folder'">Open this folder</span>
        </a>
      </div>
    </div>
  `,
  styles: [`
    :host{
      position: fixed;
      width: calc(100% - 2px);
      height: 52px;
      top: auto;
      bottom: 1px;
      left: 1px;
      background-color: #fff;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      padding: 8px 11px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      z-index: 99;
    }
    .nns-embed-logo{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      overflow: hidden;
    }
    .nns-embed-logo img{
      width: 32px;
      height: 32px;
      object-fit: cover;
    }
    .nns-embed-title{
      font-size: 16px;
      line-height: normal;
      font-weight: bold;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      align-items: center;
      color: rgba(0,0,0, 0.8);
    }
    .nns-href{
      color: #00A1B7;
      font-size: 13px;
      line-height: 16px;
      text-decoration: none;
    }
    .nns-embed-header__right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: calc(100% - 42px);
    }
    .nns-embed-header__left{
      margin-right: 10px;
    }
    .nns-embed-link{
      display: flex;
    }
  `, `
    :host-context(.nns-theme-night) {
      background:#414B4C;
    }
    :host-context(.nns-theme-night) .nns-embed-title{
      color: #fff;
    }
    :host-context(.nns-embed__video) {
      border: none;
    }
  `]
})
export class EmbedHeaderComponent implements OnChanges {
  @Input() note;
  @Input() visual;
  @Input() share;
  @Input() branding;

  websiteUrl: string;
  nimbusUrl: string;
  authUrl: string;
  fileUrl: string;
  nimbusDomain: string;
  shareUrl;

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
    public _shareCopyService: ShareCopyService,
    @Inject('isBrowser') private isBrowser: boolean,
  ) {
    this.nimbusUrl = this._config.get('NIMBUS_URL');
    this.authUrl = this._config.get('AUTH_HOST');
    this.fileUrl = this._config.get('BOX_URL') + '/file/';
    this.nimbusDomain = this._config.get('NIMBUS_DOMAIN');
  }

  ngOnChanges(changes) {
    if(changes.note && changes.note.currentValue && this.isBrowser) {
      this.shareUrl = window.location.origin + '/s' + this.note.nnShareUrl;
    }
    if(changes.share && this.isBrowser) {
      if(this.share && this.share.instance && this.share.instance.org) {
        const org = this.share.instance.org;
        if(org.domain) {
          this.websiteUrl = `https://${org.domain}/space`;
        } else if (org.sub) {
          this.websiteUrl = `https://${org.sub}.${this.nimbusDomain}/space`;
        }
      } else {
        this.websiteUrl = `${this.authUrl}/space`;
      }
    }
  }
}
